const com8F = {
	length: { min: 5, max: 5 },
	payload: [
		{ length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
		{ length: 1, name: "config", type: "bytes", description: "Configuración en horas (01), días (02) o deshabilitado (00). Tamaño: 1 byte.", values: ["00", "01", "02"], pad: "00" },
		{ length: 2, name: "time", type: "bytes", description: "Minutos desde la medianoche para realizar la medición. Entre 0 (medianoche) y 1439. Tamaño: 2 bytes.", range: { min: 0, max: 1439 } },
		{ length: 1, name: "interval", type: "bytes", description: "Frecuencia para la repetición del mensaje (en horas o días según el valor del parámetro config). Entre 1 y 30. Tamaño: 1 byte.", range: { min: 1, max: 30 } },
	],
};

export default com8F;